import {createActions} from 'reduxsauce';

export const {Types: GeoLocationTypes, Creators: GeoLocationActionCreators} = createActions ({
    geolocationStart: ['ip'],
    geolocationSuccess: ['data'],
    geolocationFailure: ['error']
});